import { blobToDownload } from "utils/helpers"
import { api } from "./api"

export const currenciesApi = api.injectEndpoints({
  endpoints: builder => ({
    downloadMarketList: builder.mutation<void, { adm0Code: number; localized: boolean }>({
      query: ({ adm0Code, localized }) => ({
        url: `/Admin/Srvc/Proxy?u=apiget/Markets/MarketsAsCSV?adm0code=${adm0Code}&localNames=${localized}`,
        method: "GET",
        responseHandler: async response =>
          blobToDownload(response, `market-list-${localized ? "localized" : "english"}.csv`),
      }),
    }),
  }),
})

export const { useDownloadMarketListMutation } = currenciesApi
